import React from 'react'
import ArticleImages from './ArticleImages'
import SubscribeForm from './SubscribeForm'
import '../styles/About.css'
import '../styles/typography.css'

const About = () => {
  return (
    <div className='about-container'>
        <div className='image-container'>
            <ArticleImages/>
        </div>
        <div className='text-container'>
            {/* <img  alt='ashe logo' className='logo-about' src={require('./Ashe-logo.png')}/> */}
            <h1>Stay Inspired!</h1>
            <h4>Get the latest issues and exclusive updates from <span>Ashe </span>Magazine!</h4>
            
            <p><span>Ashe </span> is for creatives, by creatives. People who are upcoming  or are already in their creative journey and aren’t necessarily going down the trad route of becoming successful in this field. People who are looking for relatability and understanding to feel seen and heard.
                <br/>
                <br/>
                <strong> Subscribe to our mailing list and join a thriving community of creatives today!</strong>
            </p>
            {/* <input
              className='email'
              type="text"
              placeholder="Enter your Email"
            />  */}
            <SubscribeForm/>
        </div>
    </div>
  )
}

export default About